/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { SeparateEmail } from '../SeparateEmail'

type Props = {
  platform: Platform
}

export const PaidMembershipActivationOrSubscriptionStarted = ({ platform }: Props) => (
  <SeparateEmail
    memberEmailType={EmailTemplateTypeEnum.PaidActivation}
    adminEmailType={EmailTemplateTypeEnum.PurchaseComplete}
    platformId={platform.id}
  />
)
